<template>
  <pt-previous-video class="pt-previous-video__page"></pt-previous-video>
</template>

<script>
import PtPreviousVideo from 'cps/famous-doctor-hall/pt-previous-video/withData'
export default {
  name: 'pt-previous-video__view',
  components: {
    'pt-previous-video': PtPreviousVideo
  }
}
</script>
